import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  
  const goToHome = () => {
    navigate('/');
  };
  
  return (
    <header className="bg-white shadow">
      <div className="container mx-auto px-4 py-6 flex items-center justify-between">
        <div 
          className="flex items-center space-x-2 cursor-pointer" 
          onClick={goToHome}
        >
          <svg className="w-8 h-8" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="10" width="80" height="80" rx="8" fill="url(#gradient)" />
            <path d="M30 35L50 55L70 35" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
              <linearGradient id="gradient" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="#0ea5e9" />
                <stop offset="100%" stopColor="#8b5cf6" />
              </linearGradient>
            </defs>
          </svg>
          <h1 className="text-2xl font-bold text-gray-900">ImgAI</h1>
        </div>
        <div>
          <span className="text-sm font-medium text-primary-600">Free AI Image Generator</span>
        </div>
      </div>
    </header>
  );
};

export default Header; 